export default function DefaultButton({onClick, children,}) {
    return (
        <button
          className="hover:bg-igRose font-bold m-2 uppercase rounded-xl bg-igPink active:bg-igLightGrey active:duration-75 transition-all ease-out p-2 duration-500"
          onClick={onClick}
        >
          {children}
        </button>
      );
}